import { useNavigate } from 'react-router';
import { useUpsaleDisplayQuery } from 'hooks/webapi/application/useUpsale';
import {
  useAcceptOfferMutation,
  useAcceptUpsaleMutation,
  useApplicationQuery,
  useClientOfferQuery,
  useConstraintsQuery,
} from 'hooks/webapi';
import { UPSALE_CHANGE_AMOUNT, WAITING } from 'Router/routes';

export default function useUpsale() {
  const navigate = useNavigate();

  const { data: constraints } = useConstraintsQuery();
  const { data: application } = useApplicationQuery(true);
  const { data: upsaleData, isLoading: upsaleLoading } =
    useUpsaleDisplayQuery();
  const { data: offerData, isLoading: offerDataIsLoading } =
    useClientOfferQuery(
      {
        amount: application?.proposal?.amount,
        term: application?.proposal?.term,
      },
      upsaleData?.amount !== null &&
        constraints?.termInterval.defaultValue !== null,
    );

  const { mutateAsync: acceptOffer, isPending: acceptOfferIsPending } =
    useAcceptOfferMutation();
  const { mutateAsync: acceptUpsale, isPending: acceptUpsaleIsPending } =
    useAcceptUpsaleMutation();

  const handleAccept = async () => {
    if (!application || !offerData || !upsaleData) {
      return;
    }

    // Order of these calls matter
    await acceptUpsale({
      amount: application?.proposal.amount || upsaleData.amount,
    });
    await acceptOffer({
      amount: offerData.newPrincipal,
      term: offerData.term,
    });
    navigate(WAITING);
  };

  const handleChangeAmount = () => {
    navigate(UPSALE_CHANGE_AMOUNT);
  };

  return {
    isLoading: upsaleLoading || offerDataIsLoading,
    isPending: acceptOfferIsPending || acceptUpsaleIsPending,
    handleAccept,
    handleChangeAmount,
    offer: offerData,
  };
}
